import Usluga from "~/cabinet/ts/data/usluga/Usluga";
import {USLUGA_ID_SMART_PASS} from "~/cabinet/ts/Constant";
import {useRawAsyncComponent} from "~/core-ui/ts/useRawComponent";

const SmartPass: Usluga = Usluga.new({
    id: USLUGA_ID_SMART_PASS,
    badgeValue: "New",
    dealer: {
        config: {
            tarifComponent: useRawAsyncComponent(() => import(/* webpackChunkName: "dealer-callgate" */ '~/cabinet/vue/dealer/config/uslugi/tarif/smartPass/SmartPassTarifList.vue'))
        }
    },
    client: {
        tarifComponent: useRawAsyncComponent(() => import(/* webpackChunkName: "client-callgate" */ '~/cabinet/vue/client/tarif/SmartPassTarifs.vue'))
    }
});

export default SmartPass;
